import {
  timesheetsRef,
  quotesRef,
  restoresRef,
  jobsheetsRef,
  operativesRef,
  ratesRef,
  customersRef,
} from "../firebase";

export function getDbRef(type) {
  let dbRef = null;
  if (type === "timesheet") {
    dbRef = timesheetsRef;
  }
  if (type === "quote") {
    dbRef = quotesRef;
  }
  if (type === "restore") {
    dbRef = restoresRef;
  }

  if (type === "jobsheet") {
    dbRef = jobsheetsRef;
  }

  return dbRef;
}

export function getSettingsRef(type) {
  let formRef = null;

  switch (type) {
    case "operatives":
      formRef = operativesRef;
      break;
    case "rates":
      formRef = ratesRef;
      break;
    case "customers":
      formRef = customersRef;
      break;
    default:
      formRef = null;
  }
}
